import React from 'react';

import { CopyBlock } from 'react-code-blocks';
import { styled } from 'styled-components';

import { RightSideBarContent } from 'styles/commonStyles';
import useCode from './hooks/useCode';
import { IoCopyOutline } from 'react-icons/io5';
import useModelSave from 'pages/Editor/sections/Flow/hooks/useModelSave';
import useUpdateCode from './hooks/useUpdateCode';
import UpdateBlur from './components/UpdateBlur';

const Viewer = styled.div`
  font-family: 'Source Code Pro', 'Noto Sans KR', monospace, sans-serif;
  font-size: 13px;

  & * {
    background-color: ${(props) => props.theme.global.bgColor} !important;
  }

  & > div {
    padding: 0px;
    border-radius: 0;

    & > span {
      background-color: #ffffff !important;
      padding: 0 !important;
      position: relative;
    }

    & > button {
      display: none;
      top: 0;
      right: 0;
    }
  }

  span {
    word-break: break-all;
  }
`;

const CopyButton = styled.button`
  position: absolute;
  top: 10px;
  right: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border: 1px solid ${(props) => props.theme.global.borderColor};
  border-radius: 4px;
  background-color: ${(props) => props.theme.global.bgColor};

  &:hover {
    background-color: ${(props) => props.theme.global.hoverBgColor};
  }

  svg {
    font-size: 20px;
  }
  z-index: 10;
`;

const CodeViewer = () => {
  const { showBlur, onCloseBlur } = useUpdateCode();
  const { onSaveClick } = useModelSave();
  const { code, codeTheme, onCopyClick } = useCode();

  return (
    <>
      {showBlur && <UpdateBlur onSaveClick={onSaveClick} onCloseBlur={onCloseBlur} />}
      <CopyButton onClick={onCopyClick}>
        <IoCopyOutline />
      </CopyButton>
      <RightSideBarContent style={{ height: '100%', overflow: 'auto' }}>
        {code && (
          <div>
            <Viewer>
              <CopyBlock text={code} theme={codeTheme} language="python" />
            </Viewer>
          </div>
        )}
      </RightSideBarContent>
    </>
  );
};

export default React.memo(CodeViewer);
